import { Card, Table, Row, Typography, Button, Spin, message } from "antd";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../../utils/HTTPClient";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment/moment";
import { DomainInfoModal } from "./DomainInfoModal";
import { FileSearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const DomainList = () => {
    const navigate = useNavigate();
    const [domains, setDomains] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedDomain, setSelectedDomain] = useState(null);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        const fetch = async () => {
            setLoading(true);
            const res = await HTTPClient.get("/domains/");
            const tmp_domains = res.data.map((data) => data);
            setDomains(tmp_domains);
            setLoading(false);
        };
        fetch();
    }, []);

    useEffect(() => {
        const checkForPayment = async () => {
            const success = searchParams.get("success");
            if (success) {
                message.success(t("domains.list.success_payment"));
            }
            setSearchParams("");
        };
        checkForPayment();
    }, []);

    const dataColumns = [
        {
            title: t("domains.list.fields.domain"),
            dataIndex: "domain",
            key: "domain",
        },
        {
            title: t("domains.list.fields.expiration_date"),
            dataIndex: "expiration_date",
            key: "expiration_date",
            render: (date) => moment(date).format("DD/MM/YYYY"),
        },
        {
            title: "",
            dataIndex: "dettagli",
            key: "dettagli",
            render: (_, record) => (
                <Typography.Text>
                    <Button
                        type="primary"
                        onClick={() => {
                            setOpen(true);
                            setSelectedDomain(record);
                        }}>
                        <FileSearchOutlined />
                    </Button>
                </Typography.Text>
            ),
        },
    ];

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <Row style={{ padding: isLargeScreen ? "20px 50px" : "10px 10px" }}>
            <Row>
                <Typography.Text style={{ fontSize: "36px", fontWeight: "bold" }}>
                    {t("domains.list.title")}
                </Typography.Text>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text>{t("domains.list.subtitle")}</Typography.Text>
            </Row>
            {loading || !domains ? (
                <div
                    style={{
                        width: "100%",
                        minHeight: "20vh",
                        overflow: "auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                    <Spin />
                </div>
            ) : (
                <Row style={{ width: "100%" }}>
                    {domains.length ? (
                        <Table
                            columns={dataColumns}
                            dataSource={domains}
                            pagination={false}
                            style={{ marginTop: "25px", width: "100%" }}
                        />
                    ) : (
                        <Card style={{ width: "100%", marginTop: "25px" }}>
                            <Typography.Text>{t("domains.list.empty")}</Typography.Text>
                            <div>
                                <Button
                                    type="primary"
                                    style={{ marginTop: "10px" }}
                                    onClick={() => navigate("/pro/domains/purchase")}>
                                    {t("domains.list.call_to_action")}
                                </Button>
                            </div>
                        </Card>
                    )}
                </Row>
            )}

            <DomainInfoModal
                open={open}
                setOpen={setOpen}
                domain={selectedDomain}
                setDomain={setSelectedDomain}
            />
        </Row>
    );
};

export { DomainList };
